import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable, forkJoin } from 'rxjs'
import { map } from 'rxjs/operators'
import { environment } from 'src/environments/environment'
import { AzureService } from 'src/app/core/auth/azure.service'
import { Rule } from '../models/settings.model'
import { AuditLog } from '../audit-log/audit-log.component'

const BASE_URL = environment.BASE_URL 

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private http = inject(HttpClient);
  private azureService = inject(AzureService);

  getRules(businessId?: string): Observable<any> {
    const url = `${BASE_URL}config?business_id=${businessId}`;
    const res = this.http.get(url);
    return res;
  }

  getCustomers(businessId?: string): Observable<any> {
    const url = `${BASE_URL}config/customers?business_id=${businessId}`;
    const res = this.http.get(url);
    return res;
  }

  createRules(businessId: string, rules: Rule[]): Observable<any> {
    const url = `${BASE_URL}config`;
    
    const userInfo = this.azureService.getCurrentUserValue();
    const userId = userInfo?.id || 'unknown';
    const userName = userInfo?.mail || userInfo?.displayName || 'unknown';
    
    const payload = {
      "BusinessID": businessId,
      "rules": rules,
      "userId": userId,
      "userName": userName,
    };
    
    return this.http.post(url, payload);
  }

  getAuditLog(businessId?: string): Observable<AuditLog[]> {
    const url = `${BASE_URL}config/audit`;
    return this.http.get<any>(url).pipe(
      map(response => response.auditLogs || [])
    );
  }

}
